<template>
    <transition-group class="games" name="fade" tag="div" appear>
        <!-- Date changed -> show date header-->
        <div class="date-header game row" v-if="checkDate === true" @click.prevent="toggleGames" key="game.gameDate">
            <div class="col col-5 oddsblocks header">
                <div class="oddsblock col-6 tac">{{ dateToBeShown }}</div>
            </div>
            <div class="col col-1"></div>
        </div>
        <div class="game-container" key="game._id">
            <transition-group name="slide">
                <div class="game row" @click.prevent="toggleInfo" v-if="checkToggled === true" :key="game._id">
                    <div class="col col-2 ">
                        <div class="col col-2 small-col-0"></div>
                        <div class="col col-2 small-col-6 tar small-tal">{{ game.homeTeam }}</div>
                        <div class="col col-2 small-col-6 ">- {{ game.awayTeam }}</div>
                    </div>
                    <div class="col col-3 oddsblocks percentages">
                        <template v-if="game.containsLU">
                            <template v-if="game.containsActualLU">
                                <div class="oddsblock" v-bind:class="decideBlockColour('home', game.homeOdds_lu_actual, game, game.homeOdds_lu_actual, game.drawOdds_lu_actual, game.awayOdds_lu_actual)" :style="{ width: game.homeOdds_lu_actual + '%' }">{{ game.homeOdds_lu_actual }} %</div>
                                <div class="oddsblock tac" v-bind:class="decideBlockColour('draw', game.drawOdds_lu_actual, game, game.homeOdds_lu_actual, game.drawOdds_lu_actual, game.awayOdds_lu_actual)" :style="{ width: game.drawOdds_lu_actual + '%' }">{{ game.drawOdds_lu_actual }} %</div>
                                <div class="oddsblock tar" v-bind:class="decideBlockColour('away', game.awayOdds_lu_actual, game, game.homeOdds_lu_actual, game.drawOdds_lu_actual, game.awayOdds_lu_actual)" :style="{ width: game.awayOdds_lu_actual + '%' }">{{ game.awayOdds_lu_actual }} %</div>
                            </template>
                            <template v-else>
                                <div class="oddsblock" v-bind:class="decideBlockColour('home', game.homeOdds_lu_predicted, game, game.homeOdds_lu_predicted, game.drawOdds_lu_predicted, game.awayOdds_lu_predicted)" :style="{ width: game.homeOdds_lu_predicted + '%' }">{{ game.homeOdds_lu_predicted }} %</div>
                                <div class="oddsblock tac" v-bind:class="decideBlockColour('draw', game.drawOdds_lu_predicted, game, game.homeOdds_lu_predicted, game.drawOdds_lu_predicted, game.awayOdds_lu_predicted)" :style="{ width: game.drawOdds_lu_predicted + '%' }">{{ game.drawOdds_lu_predicted }} %</div>
                                <div class="oddsblock tar" v-bind:class="decideBlockColour('away', game.awayOdds_lu_predicted, game, game.homeOdds_lu_predicted, game.drawOdds_lu_predicted, game.awayOdds_lu_predicted)" :style="{ width: game.awayOdds_lu_predicted + '%' }">{{ game.awayOdds_lu_predicted }} %</div>
                            </template>
                        </template>
                        <template v-else>
                            <template v-if="game.containsPredictedMPP">
                                <div class="oddsblock" v-bind:class="decideBlockColour('home', game.homeOdds_lu_mpp, game, game.homeOdds_lu_mpp, game.drawOdds_lu_mpp, game.awayOdds_lu_mpp)" :style="{ width: game.homeOdds_lu_mpp + '%' }">{{ game.homeOdds_lu_mpp }} %</div>
                                <div class="oddsblock tac" v-bind:class="decideBlockColour('draw', game.drawOdds_lu_mpp, game, game.homeOdds_lu_mpp, game.drawOdds_lu_mpp, game.awayOdds_lu_mpp)" :style="{ width: game.drawOdds_lu_mpp + '%' }">{{ game.drawOdds_lu_mpp }} %</div>
                                <div class="oddsblock tar" v-bind:class="decideBlockColour('away', game.awayOdds_lu_mpp, game, game.homeOdds_lu_mpp, game.drawOdds_lu_mpp, game.awayOdds_lu_mpp)" :style="{ width: game.awayOdds_lu_mpp + '%' }">{{ game.awayOdds_lu_mpp }} %</div>
                            </template>
                            <template v-else>
                                <div class="oddsblock" v-bind:class="decideBlockColour('home', game.homeOdds_lu_basic, game, game.homeOdds_lu_basic, game.drawOdds_lu_basic, game.awayOdds_lu_basic)" :style="{ width: game.homeOdds_lu_basic + '%' }">{{ game.homeOdds_lu_basic }} %</div>
                                <div class="oddsblock tac" v-bind:class="decideBlockColour('draw', game.drawOdds_lu_basic, game, game.homeOdds_lu_basic, game.drawOdds_lu_basic, game.awayOdds_lu_basic)" :style="{ width: game.drawOdds_lu_basic + '%' }">{{ game.drawOdds_lu_basic }} %</div>
                                <div class="oddsblock tar" v-bind:class="decideBlockColour('away', game.awayOdds_lu_basic, game, game.homeOdds_lu_basic, game.drawOdds_lu_basic, game.awayOdds_lu_basic)" :style="{ width: game.awayOdds_lu_basic + '%' }">{{ game.awayOdds_lu_basic }} %</div>
                            </template>
                        </template>
                        
                        <!--
                        Alkuperainen pääprosenttien mukainen (poistettu käytöstä 11.09.2020)
                        <div class="oddsblock" v-bind:class="decideBlockColour('home', game.homeOdds, game)" :style="{ width: game.homeOdds + '%' }">{{ game.homeOdds }} %</div>
                        <div class="oddsblock tac" v-bind:class="decideBlockColour('draw', game.drawOdds, game)" :style="{ width: game.drawOdds + '%' }">{{ game.drawOdds }} %</div>
                        <div class="oddsblock tar" v-bind:class="decideBlockColour('away', game.awayOdds, game)" :style="{ width: game.awayOdds + '%' }">{{ game.awayOdds }} %</div>-->
                    </div>
                    <div class="col col-1">
                        <!-- Result -->
                        <div class="row">
                            <div class="col col-1 small-col-3 no-wrap icon-text result" v-if="!upcoming">
                                {{ game.homeGoals }} - {{ game.awayGoals }}
                            </div>
                            <template v-else>
                                <template v-if="game.containsLU">
                                    <template v-if="game.containsActualLU">
                                        <div class="col col-1 small-col-3 no-wrap icon mpp_lineup" title="Probabilities are composed using actual lineup data"></div>
                                    </template>
                                    <template v-else>
                                        <div class="col col-1 small-col-3 no-wrap icon mpp_predicted" title="Probabilities are composed using predicted lineup data"></div>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-if="game.containsPredictedMPP">
                                        <div class="col col-1 small-col-3 no-wrap icon mpp_predicted" title="Probabilities are composed using predicted missing player data"></div>                                    
                                    </template>
                                    <template v-else>
                                        <div class="col col-1 small-col-3 no-wrap icon mpp_na"  title="Probabilities are composed without using player data"></div>
                                    </template>
                                </template>
                            </template>
                            <div :class="['col', 'col-3', 'icon', 'icon-left', game.fullSafeTag]" :title="fullSafeInfoText"></div>
                        </div>
                    </div>
                    <!-- Additional info -->
                    <transition-group name="slide">
                    <div class="info" v-show="toggled" key="info">
                        <div class="game row no-opacity-change">
                            <div class="col col-2 tar colSub colTextBackground">
                                <span class="full-text">Minimum Fair Odds</span>
                                <span class="short-text">Min. Fair Odds</span>
                            </div>
                            <template v-if="game.containsLU">
                                <template v-if="game.containsActualLU">
                                    <div class="col col-3 oddsblocks colBackgroundSecondary">
                                        <div class="oddsblock basicHome transparent" :title="game.homeOdds_lu_actual + ' %'">
                                            <span>{{ (1/(game.homeOdds_lu_actual/100)).toFixed(2) }}</span>
                                        </div>
                                        <div class="oddsblock basicHome transparent">
                                            <span> - </span>
                                        </div>
                                        <div class="oddsblock basicDraw tac transparent" :title="game.drawOdds_lu_actual + ' %'">
                                            <span>{{ (1/(game.drawOdds_lu_actual/100)).toFixed(2) }}</span>
                                        </div>
                                        <div class="oddsblock basicDraw tac transparent">
                                            <span> - </span>
                                        </div>
                                        <div class="oddsblock basicAway tar transparent" :title="game.awayOdds_lu_actual + ' %'">
                                            <span>{{ (1/(game.awayOdds_lu_actual/100)).toFixed(2) }}</span>
                                        </div>
                                    </div>
                                    <!--
                                    <div class="col col-3 oddsblocks colBackgroundSecondary">
                                        <div class="oddsblock basicHome transparent" :style="{ width: game.homeOdds_lu_actual + '%' }" :title="game.homeOdds_lu_actual + ' %'">
                                            <span>{{ (1/(game.homeOdds_lu_actual/100)).toFixed(2) }}</span>
                                        </div>
                                        <div class="oddsblock basicDraw tac transparent" :style="{ width: game.drawOdds_lu_actual + '%' }" :title="game.drawOdds_lu_actual + ' %'">
                                            <span>{{ (1/(game.drawOdds_lu_actual/100)).toFixed(2) }}</span>
                                        </div>
                                        <div class="oddsblock basicAway tar transparent" :style="{ width: game.awayOdds_lu_actual + '%' }" :title="game.awayOdds_lu_actual + ' %'">
                                            <span>{{ (1/(game.awayOdds_lu_actual/100)).toFixed(2) }}</span>
                                        </div>
                                    </div>
                                    -->
                                </template>
                                <template v-else>
                                    <div class="col col-3 oddsblocks colBackgroundSecondary">
                                        <div class="oddsblock basicHome transparent" :title="game.homeOdds_lu_predicted + ' %'">
                                            <span>{{ (1/(game.homeOdds_lu_mpp/100)).toFixed(2) }}</span>
                                        </div>
                                        <div class="oddsblock basicHome transparent">
                                            <span> - </span>
                                        </div>
                                        <div class="oddsblock basicDraw tac transparent" :title="game.drawOdds_lu_predicted + ' %'">
                                            <span>{{ (1/(game.drawOdds_lu_predicted/100)).toFixed(2) }}</span>
                                        </div>
                                        <div class="oddsblock basicDraw tac transparent">
                                            <span> - </span>
                                        </div>
                                        <div class="oddsblock basicAway tar transparent" :title="game.awayOdds_lu_predicted + ' %'">
                                            <span>{{ (1/(game.awayOdds_lu_predicted/100)).toFixed(2) }}</span>
                                        </div>
                                    </div>
                                    <!--
                                    <div class="col col-3 oddsblocks colBackgroundSecondary">
                                        <div class="oddsblock basicHome transparent" :style="{ width: game.homeOdds_lu_predicted + '%' }" :title="game.homeOdds_lu_predicted + ' %'">
                                            <span>{{ (1/(game.homeOdds_lu_mpp/100)).toFixed(2) }}</span>
                                        </div>
                                        <div class="oddsblock basicDraw tac transparent" :style="{ width: game.drawOdds_lu_predicted + '%' }" :title="game.drawOdds_lu_predicted + ' %'">
                                            <span>{{ (1/(game.drawOdds_lu_predicted/100)).toFixed(2) }}</span>
                                        </div>
                                        <div class="oddsblock basicAway tar transparent" :style="{ width: game.awayOdds_lu_predicted + '%' }" :title="game.awayOdds_lu_predicted + ' %'">
                                            <span>{{ (1/(game.awayOdds_lu_predicted/100)).toFixed(2) }}</span>
                                        </div>
                                    </div>
                                    -->
                                </template>
                            </template>
                            <template v-else-if="game.containsPredictedMPP">
                                <div class="col col-3 oddsblocks colBackgroundSecondary">
                                    <div class="oddsblock basicHome transparent" :title="game.homeOdds_lu_mpp + ' %'">
                                        <span>{{ (1/(game.homeOdds_lu_mpp/100)).toFixed(2) }}</span>
                                    </div>
                                    <div class="oddsblock basicHome transparent">
                                        <span> - </span>
                                    </div>
                                    <div class="oddsblock basicDraw tac transparent" :title="game.drawOdds_lu_mpp + ' %'">
                                        <span>{{ (1/(game.drawOdds_lu_mpp/100)).toFixed(2) }}</span>
                                    </div>
                                    <div class="oddsblock basicDraw tac transparent">
                                        <span> - </span>
                                    </div>
                                    <div class="oddsblock basicAway tar transparent" :title="game.awayOdds_lu_mpp + ' %'">
                                        <span>{{ (1/(game.awayOdds_lu_mpp/100)).toFixed(2) }}</span>
                                    </div>
                                </div>
                                <!--
                                <div class="col col-3 oddsblocks colBackgroundSecondary">
                                    <div class="oddsblock basicHome transparent" :style="{ width: game.homeOdds_lu_mpp + '%' }" :title="game.homeOdds_lu_mpp + ' %'">
                                        <span>{{ (1/(game.homeOdds_lu_mpp/100)).toFixed(2) }}</span>
                                    </div>
                                    <div class="oddsblock basicDraw tac transparent" :style="{ width: game.drawOdds_lu_mpp + '%' }" :title="game.drawOdds_lu_mpp + ' %'">
                                        <span>{{ (1/(game.drawOdds_lu_mpp/100)).toFixed(2) }}</span>
                                    </div>
                                    <div class="oddsblock basicAway tar transparent" :style="{ width: game.awayOdds_lu_mpp + '%' }" :title="game.awayOdds_lu_mpp + ' %'">
                                        <span>{{ (1/(game.awayOdds_lu_mpp/100)).toFixed(2) }}</span>
                                    </div>
                                </div>
                                -->
                            </template>
                            <template v-else>
                                <div class="col col-3 oddsblocks colBackgroundSecondary">
                                    <div class="oddsblock basicHome transparent" :title="game.homeOdds_lu_basic + ' %'">
                                        <span>{{ (1/(game.homeOdds_lu_basic/100)).toFixed(2) }}</span>
                                    </div>
                                    <div class="oddsblock basicHome transparent">
                                        <span> - </span>
                                    </div>
                                    <div class="oddsblock basicDraw tac transparent" :title="game.drawOdds_lu_basic + ' %'">
                                        <span>{{ (1/(game.drawOdds_lu_basic/100)).toFixed(2) }}</span>
                                    </div>
                                    <div class="oddsblock basicDraw tac transparent">
                                        <span> - </span>
                                    </div>
                                    <div class="oddsblock basicAway tar transparent" :title="game.awayOdds_lu_basic + ' %'">
                                        <span>{{ (1/(game.awayOdds_lu_basic/100)).toFixed(2) }}</span>
                                    </div>
                                </div>
                                <!--
                                <div class="col col-3 oddsblocks colBackgroundSecondary">
                                    <div class="oddsblock basicHome transparent" :style="{ width: game.homeOdds_lu_basic + '%' }" :title="game.homeOdds_lu_basic + ' %'">
                                        <span>{{ (1/(game.homeOdds_lu_basic/100)).toFixed(2) }}</span>
                                    </div>
                                    <div class="oddsblock basicDraw tac transparent" :style="{ width: game.drawOdds_lu_basic + '%' }" :title="game.drawOdds_lu_basic + ' %'">
                                        <span>{{ (1/(game.drawOdds_lu_basic/100)).toFixed(2) }}</span>
                                    </div>
                                    <div class="oddsblock basicAway tar transparent" :style="{ width: game.awayOdds_lu_basic + '%' }" :title="game.awayOdds_lu_basic + ' %'">
                                        <span>{{ (1/(game.awayOdds_lu_basic/100)).toFixed(2) }}</span>
                                    </div>
                                </div>
                                -->
                            </template>
                            <div class="col col-1"></div>
                        </div>
                        <template v-if="game.containsLU && game.containsPredictedMPP">

                            <div class="game row no-opacity-change">
                            
                                <div class="col col-2 tar colSub colTextBackground">
                                    <span class="full-text">Combined points based on Predicted Players</span>
                                    <span class="short-text">Pts. with Pred. Plrs</span>
                                </div>

                            <!--<div class="col col-2 tar colSub colTextBackground">Predicted Players</div> -->
                                <div class="col col-3 oddsblocks colBackgroundSecondary">
                                    <div class="oddsblock basicHome" v-bind:class="decideBlockColourSecondary('home', game.homeOdds_lu_mpp, game, game.homeOdds_lu_mpp, game.drawOdds_lu_mpp, game.awayOdds_lu_mpp)" :style="{ width: game.homeOdds_lu_mpp + '%' }" :title="game.homeOdds_lu_mpp + ' %'">
                                        <span>{{ game.homeOdds_lu_mpp }} %</span>
                                    </div>
                                    <div class="oddsblock basicDraw tac" v-bind:class="decideBlockColourSecondary('draw', game.drawOdds_lu_mpp, game, game.homeOdds_lu_mpp, game.drawOdds_lu_mpp, game.awayOdds_lu_mpp)" :style="{ width: game.drawOdds_lu_mpp + '%' }" :title="game.drawOdds_lu_mpp + ' %'">
                                        <span>{{ game.drawOdds_lu_mpp }} %</span>
                                    </div>
                                    <div class="oddsblock basicAway tar" v-bind:class="decideBlockColourSecondary('away', game.awayOdds_lu_mpp, game, game.homeOdds_lu_mpp, game.drawOdds_lu_mpp, game.awayOdds_lu_mpp)" :style="{ width: game.awayOdds_lu_mpp + '%' }" :title="game.awayOdds_lu_mpp + ' %'">
                                        <span>{{ game.awayOdds_lu_mpp }} %</span>
                                    </div>
                                </div>
                                <div class="col col-1">
                                    <div class="row">
                                        <div title="Probabilities are composed using predicted missing player data" class="col col-1 small-col-3 no-wrap icon mpp_predicted"></div><div data-v-6ca3af22="" title="" class="col col-3 icon icon-left NOT_SET">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="game row no-opacity-change">

                                <div class="col col-2 tar colSub colTextBackground">
                                    <span class="full-text">Combined points without player data</span>
                                    <span class="short-text">Pts. w/o Pred. Plrs</span>
                                </div>
                                
                            <!-- <div class="col col-2 tar colSub colTextBackground">No Player Data</div> -->
                                <div class="col col-3 oddsblocks colBackgroundSecondary">
                                    <div class="oddsblock basicHome" v-bind:class="decideBlockColourSecondary('home', game.homeOdds_lu_basic, game, game.homeOdds_lu_basic, game.drawOdds_lu_basic, game.awayOdds_lu_basic)" :style="{ width: game.homeOdds_lu_basic + '%' }" :title="game.homeOdds_lu_basic + ' %'">
                                        <span>{{ game.homeOdds_lu_basic }} %</span>
                                    </div>
                                    <div class="oddsblock basicDraw tac" v-bind:class="decideBlockColourSecondary('draw', game.drawOdds_lu_basic, game, game.homeOdds_lu_basic, game.drawOdds_lu_basic, game.awayOdds_lu_basic)" :style="{ width: game.drawOdds_lu_basic + '%' }" :title="game.drawOdds_lu_basic + ' %'">
                                        <span>{{ game.drawOdds_lu_basic }} %</span>
                                    </div>
                                    <div class="oddsblock basicAway tar" v-bind:class="decideBlockColourSecondary('away', game.awayOdds_lu_basic, game, game.homeOdds_lu_basic, game.drawOdds_lu_basic, game.awayOdds_lu_basic)" :style="{ width: game.awayOdds_lu_basic + '%' }" :title="game.awayOdds_lu_basic + ' %'">
                                        <span>{{ game.awayOdds_lu_basic }} %</span>
                                    </div>
                                </div>
                                <div class="col col-1">
                                    <div class="row">
                                        <div title="Probabilities are composed without missing player data" class="col col-1 small-col-3 no-wrap icon mpp_na"></div><div data-v-6ca3af22="" title="" class="col col-3 icon icon-left NOT_SET">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="game.containsPredictedMPP || game.containsLU">
                            <div class="game row no-opacity-change">

                                <div class="col col-2 tar colSub colTextBackground">
                                    <span class="full-text">Combined points without player data</span>
                                    <span class="short-text">Pts. w/o Pred. Plrs</span>
                                </div>

                                <div class="col col-3 oddsblocks colBackgroundSecondary">
                                    <div class="oddsblock basicHome" v-bind:class="decideBlockColourSecondary('home', game.homeOdds_lu_basic, game, game.homeOdds_lu_basic, game.drawOdds_lu_basic, game.awayOdds_lu_basic)" :style="{ width: game.homeOdds_lu_basic + '%' }" :title="game.homeOdds_lu_basic + ' %'">
                                        <span>{{ game.homeOdds_lu_basic }} %</span>
                                    </div>
                                    <div class="oddsblock basicDraw tac" v-bind:class="decideBlockColourSecondary('draw', game.drawOdds_lu_basic, game, game.homeOdds_lu_basic, game.drawOdds_lu_basic, game.awayOdds_lu_basic)" :style="{ width: game.drawOdds_lu_basic + '%' }" :title="game.drawOdds_lu_basic + ' %'">
                                        <span>{{ game.drawOdds_lu_basic }} %</span>
                                    </div>
                                    <div class="oddsblock basicAway tar" v-bind:class="decideBlockColourSecondary('away', game.awayOdds_lu_basic, game, game.homeOdds_lu_basic, game.drawOdds_lu_basic, game.awayOdds_lu_basic)" :style="{ width: game.awayOdds_lu_basic + '%' }" :title="game.awayOdds_lu_basic + ' %'">
                                        <span>{{ game.awayOdds_lu_basic }} %</span>
                                    </div>
                                </div>
                                <div class="col col-1">
                                    <div class="row">
                                        <div title="Probabilities are composed without missing player data" class="col col-1 small-col-3 no-wrap icon mpp_na"></div><div data-v-6ca3af22="" title="" class="col col-3 icon icon-left NOT_SET">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- Burden / SLEEP NEEDED (icon) -->
                        <div class="game row">
                            <div class="col col-2 tar colSub colTextBackground"></div>
                            <div class="col col-3 oddsblocks colBackground">
                                <div :class="[game.homeBurden, 'icon', 'icon-left', 'col', 'col-2', 'small-col-3']">
                                </div>
                                <div class="col-2 col small-col-0">
                                </div>
                                <div :class="[game.awayBurden, 'icon', 'icon-right', 'tar', 'col', 'col-2', 'small-col-3']">
                                </div>
                            </div>
                            <div class="col col-1"></div>
                        </div>
                        <!-- Burden / SLEEP NEEDED (text) -->
                        <div class="game row">
                            <!--<div class="col col-2 ">
                                <div class="col col-6 tar secondaryOddsText">Burden</div>
                            </div>-->
                            <div class="col col-2 tar colSub colTextBackground">Burden</div>
                            <div class="col col-3 oddsblocks colBackground">
                                <div class="col col-2 small-col-3 burdenText">{{ getFirstBurdenText(game.homeBurden) }}</div>
                                <div class="col-2 col small-col-0">
                                </div>
                                <div class="tar col col-2 small-col-3 burdenText">{{ getFirstBurdenText(game.awayBurden) }}
                                </div>
                            </div>
                            <div class="col col-2 tar colSub colTextBackground"></div>
                            <div class="col col-3 oddsblocks colBackground">
                                <div class="col col-2 small-col-3 burdenText">{{ getSecondBurdenText(game.homeBurden) }}</div>
                                <div class="col-2 col small-col-0">
                                </div>
                                <div class="tar col col-2 small-col-3 burdenText">{{ getSecondBurdenText(game.awayBurden) }}
                                </div>
                            </div>
                            <div class="col col-1"></div>
                        </div>
                        <!-- Let's loop through additional info blocks -->
                        <div v-for="block in blocks" v-bind:key="block.name">
                            <div class="game row">
                                <div class="col col-2 tar colSub colTextBackground">{{ block.name }}</div>
                                <div class="col col-3 oddsblocks colBackground">
                                    
                                    <template v-if="block.home > block.draw && block.home > block.away && decideIfCorrelatesWithMainBlock('HOME')">
                                        <div class="oddssubblock basicHomeHighest" :style="{ width: block.home + '%' }" :title="block.name + ' (Home) : ' + block.home + ' %'">
                                        <span>{{ block.home.toFixed(0) }} %</span>
                                    </div>
                                    </template>
                                    <template v-else>
                                        <div class="oddssubblock basicHome" :style="{ width: block.home + '%' }" :title="block.name + ' (Home) : ' + block.home + ' %'">
                                        <span>{{ block.home.toFixed(0) }} %</span>
                                        </div>
                                    </template>

                                    <template v-if="block.draw > block.home && block.draw > block.away && decideIfCorrelatesWithMainBlock('DRAW')">
                                        <div class="oddssubblock basicDrawHighest tac" :style="{ width: block.draw + '%' }" :title="block.name + ' (Draw) : ' + block.draw + ' %'">
                                        <span>{{ block.draw.toFixed(0) }} %</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="oddssubblock basicDraw tac" :style="{ width: block.draw + '%' }" :title="block.name + ' (Draw) : ' + block.draw + ' %'">
                                        <span>{{ block.draw.toFixed(0) }} %</span>
                                        </div>
                                    </template>

                                    <template v-if="block.away > block.home && block.away > block.draw && decideIfCorrelatesWithMainBlock('AWAY')">
                                        <div class="oddssubblock basicAwayHighest tar" :style="{ width: block.away + '%' }" :title="block.name + ' (Away) : ' + block.away + ' %'">
                                        <span>{{ block.away.toFixed(0) }} %</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="oddssubblock basicAway tar" :style="{ width: block.away + '%' }" :title="block.name + ' (Away) : ' + block.away + ' %'">
                                        <span>{{ block.away.toFixed(0) }} %</span>
                                        </div>
                                    </template>
                                    
                                </div>
                                <div class="col col-1"></div>
                            </div>
                        </div>
                        <!-- Additional info: Missing players -->
                        <div class="game row"  >
                            <div class="col col-2 tar colSub colTextBackground full-text">Predicted Missing Players</div>
                            <div class="col col-2 tar colSub colTextBackground short-text">Pred. Missing Plrs</div>
                            <div class="col col-3 oddsblocks colBackground">
                                <template v-if="game.containsPredictedMPP">
                                    <div class="oddssubblockmpptxt tac">
                                        <span></span>
                                    </div>

                                    <template v-if="game.block_13_mpp_tot_home > game.block_13_mpp_tot_draw && game.block_13_mpp_tot_home > game.block_13_mpp_tot_away && decideIfCorrelatesWithMainBlock('HOME') && (game.containsLU == false)">
                                        <div class="oddssubblock basicHomeHighest" :style="{ width: game.block_13_mpp_tot_home + '%' }" :title="'Predicted Plrs (Home) : ' + game.block_13_mpp_tot_home + ' %'">
                                        <span>{{ game.block_13_mpp_tot_home.toFixed(0) }} %</span>
                                        </div> 
                                    </template>
                                    <template v-else>
                                        <div class="oddssubblock basicHome" :style="{ width: game.block_13_mpp_tot_home + '%' }" :title="'Predicted Plrs (Home) : ' + game.block_13_mpp_tot_home + ' %'">
                                        <span>{{ game.block_13_mpp_tot_home.toFixed(0) }} %</span>
                                        </div> 
                                    </template>

                                    <template v-if="game.block_13_mpp_tot_draw > game.block_13_mpp_tot_home && game.block_13_mpp_tot_draw > game.block_13_mpp_tot_away && decideIfCorrelatesWithMainBlock('DRAW') && (game.containsLU == false)">
                                        <div class="oddssubblock basicDrawHighest tac" :style="{ width: game.block_13_mpp_tot_draw + '%' }" :title="'Predicted Plrs (Draw) : ' + game.block_13_mpp_tot_draw + ' %'">
                                        <span>{{ game.block_13_mpp_tot_draw.toFixed(0) }} %</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="oddssubblock basicDraw tac" :style="{ width: game.block_13_mpp_tot_draw + '%' }" :title="'Predicted Plrs (Draw) : ' + game.block_13_mpp_tot_draw + ' %'">
                                        <span>{{ game.block_13_mpp_tot_draw.toFixed(0) }} %</span>
                                        </div>
                                    </template>

                                    <template v-if="game.block_13_mpp_tot_away > game.block_13_mpp_tot_home && game.block_13_mpp_tot_away > game.block_13_mpp_tot_draw && decideIfCorrelatesWithMainBlock('AWAY') && (game.containsLU == false)">
                                        <div class="oddssubblock basicAwayHighest tar" :style="{ width: game.block_13_mpp_tot_away + '%' }" :title="'Predicted Plrs (Away) : ' + game.block_13_mpp_tot_away + ' %'">
                                        <span>{{ game.block_13_mpp_tot_away.toFixed(0) }} %</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="oddssubblock basicAway tar" :style="{ width: game.block_13_mpp_tot_away + '%' }" :title="'Predicted Plrs (Away) : ' + game.block_13_mpp_tot_away + ' %'">
                                        <span>{{ game.block_13_mpp_tot_away.toFixed(0) }} %</span>
                                        </div>
                                    </template>

                                </template>
                                <template v-else >
                                    <div class="oddssubblockempty basicAway tac">
                                        <span>{{ "N/A" }}</span>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="game row"  >
                            <template v-if="game.containsLU">
                                <template v-if="game.containsActualLU">
                                    <div class="col col-2 tar colSub colTextBackground">
                                        Final Lineup
                                    </div>
                                    <div class="col col-3 oddsblocks colBackground">

                                        <template v-if="game.block_13_lu_actual_tot_home > game.block_13_lu_actual_tot_draw && game.block_13_lu_actual_tot_home > game.block_13_lu_actual_tot_away && decideIfCorrelatesWithMainBlock('HOME')">
                                            <div class="oddssubblock basicHomeHighest" :style="{ width: game.block_13_lu_actual_tot_home + '%' }" :title="'Final Lineup (Home) : ' + game.block_13_lu_actual_tot_home + ' %'">
                                            <span>{{ game.block_13_lu_actual_tot_home.toFixed(0) }} %</span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="oddssubblock basicHome" :style="{ width: game.block_13_lu_actual_tot_home + '%' }" :title="'Final Lineup (Home) : ' + game.block_13_lu_actual_tot_home + ' %'">
                                            <span>{{ game.block_13_lu_actual_tot_home.toFixed(0) }} %</span>
                                            </div>
                                        </template>

                                        <template v-if="game.block_13_lu_actual_tot_draw > game.block_13_lu_actual_tot_home && game.block_13_lu_actual_tot_draw > game.block_13_lu_actual_tot_away  && decideIfCorrelatesWithMainBlock('DRAW')">
                                            <div class="oddssubblock basicDrawHighest tac" :style="{ width: game.block_13_lu_actual_tot_draw + '%' }" :title="'Final Lineup (Draw) : ' + game.block_13_lu_actual_tot_draw + ' %'">
                                            <span>{{ game.block_13_lu_actual_tot_draw.toFixed(0) }} %</span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="oddssubblock basicDraw tac" :style="{ width: game.block_13_lu_actual_tot_draw + '%' }" :title="'Final Lineup (Draw) : ' + game.block_13_lu_actual_tot_draw + ' %'">
                                            <span>{{ game.block_13_lu_actual_tot_draw.toFixed(0) }} %</span>
                                            </div>
                                        </template>

                                        <template v-if="game.block_13_lu_actual_tot_away > game.block_13_lu_actual_tot_home && game.block_13_lu_actual_tot_away > game.block_13_lu_actual_tot_draw && decideIfCorrelatesWithMainBlock('AWAY')">
                                            <div class="oddssubblock basicAwayHighest tar" :style="{ width: game.block_13_lu_actual_tot_away + '%' }" :title="'Final Lineup (Away) : ' + game.block_13_lu_actual_tot_away + ' %'">
                                            <span>{{ game.block_13_lu_actual_tot_away.toFixed(0) }} %</span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="oddssubblock basicAway tar" :style="{ width: game.block_13_lu_actual_tot_away + '%' }" :title="'Final Lineup (Away) : ' + game.block_13_lu_actual_tot_away + ' %'">
                                            <span>{{ game.block_13_lu_actual_tot_away.toFixed(0) }} %</span>
                                            </div>
                                        </template>

                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col col-2 tar colSub colTextBackground">
                                        <span>Predicted Lineup</span>
                                    </div>
                                    <div class="col col-3 oddsblocks colBackground">
                                        

                                        <template v-if="game.block_13_lu_predicted_tot_home > game.block_13_lu_predicted_tot_draw && game.block_13_lu_predicted_tot_home > game.block_13_lu_predicted_tot_away && decideIfCorrelatesWithMainBlock('HOME')">
                                            <div class="oddssubblock basicHomeHighest" :style="{ width: game.block_13_lu_predicted_tot_home + '%' }" :title="'Predicted Lineup (Home) : ' + game.block_13_lu_predicted_tot_home + ' %'">
                                            <span>{{ game.block_13_lu_predicted_tot_home.toFixed(0) }} %</span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="oddssubblock basicHome" :style="{ width: game.block_13_lu_predicted_tot_home + '%' }" :title="'Predicted Lineup (Home) : ' + game.block_13_lu_predicted_tot_home + ' %'">
                                            <span>{{ game.block_13_lu_predicted_tot_home.toFixed(0) }} %</span>
                                            </div>
                                        </template>

                                        <template v-if="game.block_13_lu_predicted_tot_draw > game.block_13_lu_predicted_tot_home && game.block_13_lu_predicted_tot_draw > game.block_13_lu_predicted_tot_away && decideIfCorrelatesWithMainBlock('DRAW')">
                                            <div class="oddssubblock basicDrawHighest tac" :style="{ width: game.block_13_lu_predicted_tot_draw + '%' }" :title="'Predicted Lineup (Draw) : ' + game.block_13_lu_predicted_tot_draw + ' %'">
                                            <span>{{ game.block_13_lu_predicted_tot_draw.toFixed(0) }} %</span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="oddssubblock basicDraw tac" :style="{ width: game.block_13_lu_predicted_tot_draw + '%' }" :title="'Predicted Lineup (Draw) : ' + game.block_13_lu_predicted_tot_draw + ' %'">
                                            <span>{{ game.block_13_lu_predicted_tot_draw.toFixed(0) }} %</span>
                                            </div>
                                        </template>

                                        <template v-if="game.block_13_lu_predicted_tot_away > game.block_13_lu_predicted_tot_home && game.block_13_lu_predicted_tot_away > game.block_13_lu_predicted_tot_draw && decideIfCorrelatesWithMainBlock('AWAY')">
                                            <div class="oddssubblock basicAwayHighest tar" :style="{ width: game.block_13_lu_predicted_tot_away + '%' }" :title="'Predicted Lineup (Away) : ' + game.block_13_lu_predicted_tot_away + ' %'">
                                            <span>{{ game.block_13_lu_predicted_tot_away.toFixed(0) }} %</span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="oddssubblock basicAway tar" :style="{ width: game.block_13_lu_predicted_tot_away + '%' }" :title="'Predicted Lineup (Away) : ' + game.block_13_lu_predicted_tot_away + ' %'">
                                            <span>{{ game.block_13_lu_predicted_tot_away.toFixed(0) }} %</span>
                                            </div>
                                        </template>


                                        <div class="oddssubblock basicHome" :style="{ width: game.block_13_lu_predicted_tot_home + '%' }">
                                        <span>{{ game.block_13_lu_predicted_tot_home }} %</span>
                                        </div>

                                        <div class="oddssubblock basicDraw tac" :style="{ width: game.block_13_lu_predicted_tot_draw + '%' }">
                                        <span>{{ game.block_13_lu_predicted_tot_draw }} %</span>
                                        </div>
                                        
                                        <div class="oddssubblock basicAway tar" :style="{ width: game.block_13_lu_predicted_tot_away + '%' }">
                                        <span>{{ game.block_13_lu_predicted_tot_away }} %</span>
                                        </div>

                                    </div>
                                </template>
                            </template>
                            <template v-else>
                                <div class="col col-2 tar colSub colTextBackground">
                                    <span>Final lineup</span>
                                </div>
                                <div class="col col-3 oddsblocks colBackground">
                                    <div class="oddssubblockempty basicAway tac">
                                        <span>{{ "N/A" }}</span>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="game row"  >
                            <div class="col col-2 tar colSub colTextBackground possible-upset">Possible upset</div>
                            <div class="col col-3 oddsblocks colBackground">
                                <div v-if="game.fullSafeTag == 'NOT_SET'" class="oddssubblockempty basicAway tac">
                                    <span>{{ "N/A" }}</span>
                                </div>
                                <div v-else class="tac basicAway">
                                    <span>{{ fullSafeInfoText }}</span>
                                </div>
                            </div>
                            <div class="col col-1"></div>
                        </div>
                    </div>
                    </transition-group>
                </div>  
            </transition-group>
        </div>
    </transition-group>
</template>

<script>
export default {
    props: {
        game: {
            type: Object,
            required: true
        }, 
        upcoming: {
            type: Boolean,
            required: true
        },
        toggledDates: {
            type: Array,
            required: false
        }
    },
    data: function() {
        return {
            toggled: false,
            blocks: [
                { name: 'H/A Streak', home: this.game.block_1_str_ha_home, draw: this.game.block_1_str_ha_draw, away: this.game.block_1_str_ha_away},
                { name: 'H/A H2H', home: this.game.block_2_h2h_ha_home, draw: this.game.block_2_h2h_ha_draw, away: this.game.block_2_h2h_ha_away},
                { name: 'TOTAL Streak', home: this.game.block_3_str_tot_home, draw: this.game.block_3_str_tot_draw, away: this.game.block_3_str_tot_away},
                { name: 'TOTAL H2H', home: this.game.block_4_h2h_tot_home, draw: this.game.block_4_h2h_tot_draw, away: this.game.block_4_h2h_tot_away},
                { name: 'H/A Scoring', home: this.game.block_5_score_ha_home, draw: this.game.block_5_score_ha_draw, away: this.game.block_5_score_ha_away},
                { name: 'H/A Conceding', home: this.game.block_6_concede_ha_home, draw: this.game.block_6_concede_ha_draw, away: this.game.block_6_concede_ha_away},
                { name: 'TOTAL Scoring', home: this.game.block_7_score_tot_home, draw: this.game.block_7_score_tot_draw, away: this.game.block_7_score_tot_away},
                { name: 'TOTAL Conceding', home: this.game.block_8_concede_tot_home, draw: this.game.block_8_concede_tot_draw, away: this.game.block_8_concede_tot_away},
                { name: 'H/A Matches', home: this.game.block_9_matches_ha_home, draw: this.game.block_9_matches_ha_draw, away: this.game.block_9_matches_ha_away},
                { name: 'TOTAL Matches', home: this.game.block_10_matches_tot_home, draw: this.game.block_10_matches_tot_draw, away: this.game.block_10_matches_tot_away},
                { name: 'H/A Last Matches', home: this.game.block_11_last_matches_ha_home, draw: this.game.block_11_last_matches_ha_draw, away: this.game.block_11_last_matches_ha_away},
                { name: 'TOTAL Last Matches', home: this.game.block_12_last_matches_tot_home, draw: this.game.block_12_last_matches_tot_draw, away: this.game.block_12_last_matches_tot_away},

            ],
        }
    },
    computed: {
        checkDate() {
            if (!this.upcoming) {
                if ( this.$parent.activeDate != this.game.gameDate ) {
                    this.$emit('update-date', this.game.gameDate)
                    return true;
                } else {
                    return false;
                }
            }
            return false;
        },
        checkToggled() {
            if (!this.upcoming) {
                if ( this.toggledDates.indexOf(this.game.gameDate ) > -1) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        dateToBeShown() {
            let tmp = new Date(this.game.gameDate);
            let options = { year: 'numeric', month: 'long', day: 'numeric' };
            return tmp.toLocaleDateString('en-GB', options); // Let's show the date as DD/MM/YYYY
        },
        fullSafeInfoText() {
            if(this.game.fullSafeTag == 'FULL_SAFE_STYLE_PAIR') {
                return 'Team styles are deemed unpredictable';
            } 
            else if(this.game.fullSafeTag == 'FULL_SAFE_DOM_PASSIVE') {
                return 'Team with lower win probability might dominate game flow or team with higher win probability has been performing inconsistently against \'weaker\' opponents';
            } else if(this.game.fullSafeTag == 'INJURY_CHANGES_FAV') {
                return 'Option with highest win probability is that only because of missing players';
            } 
            else if(this.game.fullSafeTag == 'INJURY_TOO_BIG') {
                return 'Team with higher win probability has important players missing from lineup';
            } 
            else if(this.game.fullSafeTag == 'BURDEN_TOO_BIG') {
                return 'Team with higher win probability has had tigh schedule and players might be tired';
            } 
            else if(this.game.fullSafeTag == 'STYLE_BASED_H2H') {
                return 'Teams have played contrary to calculated probabilities against similarly styled opponents';
            } 
            else if(this.game.fullSafeTag == 'STREAK_TOO_LONG') {
                return 'Either one of the teams is on statistically too long winning/losing/drawing streak';
            } 
            else if(this.game.fullSafeTag == 'INCONSISTENT_FAV') {
                return 'Team with higher win probability has been performing inconsistently against opponents similiar to current one';
            }
            else if(this.game.fullSafeTag == 'DRAW_TOO_CLOSE') {
                return 'Teams have played evenly against similarly styled opponents';
            }
            else if(this.game.fullSafeTag == 'LOW_SCORING') {
                return 'Both teams are relatively low scoring';
            }
            else if(this.game.fullSafeTag == 'MIXED_LG_STREAK') {
                return 'Recent matches show irregularities in both teams current form';
            }
            else if(this.game.fullSafeTag == 'FORCED_STREAK') {
                return 'Either one of the teams is on statistically long winning/losing/drawing streak + key statistics do not point to a definite favorite';
            }
            else if(this.game.fullSafeTag == 'MANAGER_CHANGE') {
                return 'Team with lower win probability has changed manager recently';
            }
            else if(this.game.fullSafeTag == 'FAV_COUNTER_VS_POOR') {
                return 'Team with higher win probability usually relies on counterattacking style but might be forced to change tactics against more passive team';
            } else {
                return '';
            }
        },
    },
    methods: {
        toggleInfo() {
            this.toggled = !this.toggled;
        },
        /*formatPercentage(amount) {
            if (amount < 20) {
                // alle 20 prosenttisille ei laiteta prosenttimerkkia
                return amount;
            } else {
                return amount + '%';
            }
        },
        calculateBlockWidth(amount, homeOdds, drawOdds, awayOdds) {
            
            // check if any of the odds is lower than 15
            if ( homeOdds < 15 || drawOdds < 15 || awayOdds < 15 ) {
                let odds = [homeOdds, drawOdds, awayOdds];
                let maxVal = Math.max.apply(Math, odds);
                if ( amount < 15 ) {
                    // this is the lowest
                    return 15;
                } else if ( amount == maxVal ) {
                    // this is the highest -> return whatever is left
                    return 100 - (( homeOdds < 15 ? 15 : homeOdds ) + ( drawOdds < 15 ? 15 : drawOdds ) + ( awayOdds < 15 ? 15 : awayOdds ) - amount);                    
                } else {
                    return amount;
                }
            } 
            
            return amount;
        },*/
        toggleGames() {
            this.$emit('toggle-date', this.game.gameDate);
        },
        getFirstBurdenText(key) {
            if (key == 'NOT_NEEDED') {
                return 'Schedule : Normal'
            } else if ( key == 'NOT_SPECIFIC') {
                return 'Schedule : Tight'
            } else if ( key == 'SPECIFIC') {
                return 'Schedule : Tight'
            } else {
                return 'Schedule : Tight'
            }
        },
        getSecondBurdenText(key) {
            if (key == 'NOT_NEEDED') {
                return ''
            } else if ( key == 'NOT_SPECIFIC') {
                return '- No tendency to not winning as often when tired'
            } else if ( key == 'SPECIFIC') {
                return '+ Tendency of not winning as often when tired'
            } else {
                return '+ Definite tendency of not winning when tired'
            }
        },
        decideBlockColour(block, blockValue, game, homeOdds, drawOdds, awayOdds) { 
            let odds = [homeOdds, drawOdds, awayOdds];
            let maxVal = Math.max.apply(Math, odds);
            let minVal = Math.min.apply(Math, odds);
            let retVal = '';
            if (this.upcoming){
                // Upcoming block colours
                if ( blockValue == maxVal ) {
                    if( odds.filter(x => x == maxVal).length === 1 ) {
                        retVal = 'highest'
                    } else {
                        // There are several blocks with max val
                        retVal = 'oneOfHighest'
                    }
                } 
            } else {
                if ( game.homeGoals > game.awayGoals ) {
                    // 1
                    if ( block === 'home') {
                        if (homeOdds === maxVal ) {
                            // Correct guess
                            if( odds.filter(x => x == maxVal).length === 1 ) {
                                retVal = 'correctGuess';
                            } else {
                                // There are several blocks with max val
                                retVal = 'oneOfCorrect'
                            }
                        } else if ( homeOdds === minVal ) {
                            retVal = 'incorrectGuess';
                        } else {
                            retVal = 'okGuess';
                        }
                    }
                    if ( block === 'draw') {
                        if (homeOdds === maxVal ) {
                            if (homeOdds === drawOdds ) {
                                // Home and Draw option both have biggest odds
                                retVal = 'oneOfCorrect'
                            }
                        }
                    }
                    if ( block === 'away') {
                        if (homeOdds === maxVal ) {
                            if (homeOdds === awayOdds ) {
                                // Home and Away option both have biggest odds
                                retVal = 'oneOfCorrect'
                            }
                        }
                    }
                } else if ( game.homeGoals === game.awayGoals ) {
                    // X
                    if ( block === 'draw') {
                        if (drawOdds === maxVal ) {
                            // Correct guess
                            if( odds.filter(x => x == maxVal).length === 1 ) {
                                retVal = 'correctGuess';
                            } else {
                                // There are several blocks with max val
                                retVal = 'oneOfCorrect'
                            }
                        } else if ( drawOdds === minVal ) {
                            retVal = 'incorrectGuess';
                        } else {
                            retVal = 'okGuess';
                        }
                    }
                    if ( block === 'home') {
                        if (drawOdds === maxVal ) {
                            if (drawOdds === homeOdds ) {
                                // Draw and Home option both have biggest odds
                                retVal = 'oneOfCorrect'
                            }
                        }
                    }
                    if ( block === 'away') {
                        if (drawOdds === maxVal ) {
                            if (drawOdds === awayOdds ) {
                                // Draw and Away option both have biggest odds
                                retVal = 'oneOfCorrect'
                            }
                        }
                    }
                } else {
                    // 2
                    if ( block === 'away') {
                        if (awayOdds === maxVal ) {
                            // Correct guess
                            if( odds.filter(x => x == maxVal).length === 1 ) {
                                retVal = 'correctGuess';
                            } else {
                                // There are several blocks with max val
                                retVal = 'oneOfCorrect'
                            }
                        } else if ( awayOdds === minVal ) {
                            retVal = 'incorrectGuess';
                        } else {
                            retVal = 'okGuess';
                        }
                    }
                    if ( block === 'draw') {
                        if (awayOdds === maxVal ) {
                            if (awayOdds === drawOdds ) {
                                // Away and Draw option both have biggest odds
                                retVal = 'oneOfCorrect'
                            }
                        }
                    }
                    if ( block === 'away') {
                        if (awayOdds === maxVal ) {
                            if (awayOdds === homeOdds ) {
                                // Away and Home option both have biggest odds
                                retVal = 'oneOfCorrect'
                            }
                        }
                    }
                }
            }
            return retVal;
        },
        decideBlockColourSecondary(block, blockValue, game, homeOdds, drawOdds, awayOdds) {
            
            let retVal = '';

            retVal = this.decideBlockColour(block, blockValue, game, homeOdds, drawOdds, awayOdds);
        
            if ( retVal === 'incorrectGuess') {
                retVal = 'incorrectGuessSecondary'
            }else if ( retVal === 'correctGuess') {
                retVal = 'correctGuessSecondary'
            }else if ( retVal === 'oneOfCorrect') {
                retVal = 'oneOfCorrectSecondary'
            }else if ( retVal === 'okGuess') {
                retVal = 'okGuessSecondary'
            }

            return retVal;
        },
        decideIfCorrelatesWithMainBlock(option){

            /*
            option: HOME / DRAW / AWAY
            */

            let decidingHomePoints = this.game.homeOdds_lu_basic;
            let decidingDrawPoints = this.game.drawOdds_lu_basic;
            let decidingAwayPoints = this.game.awayOdds_lu_basic;

            if(this.game.containsLU)
            {
                if(this.game.containsActualLU)
                {
                    decidingHomePoints = this.game.homeOdds_lu_actual;
                    decidingDrawPoints = this.game.drawOdds_lu_actual;
                    decidingAwayPoints = this.game.awayOdds_lu_actual;
                }
                else
                {
                    decidingHomePoints = this.game.homeOdds_lu_predicted;
                    decidingDrawPoints = this.game.drawOdds_lu_predicted;
                    decidingAwayPoints = this.game.awayOdds_lu_predicted;
                }
            }
            else if(this.game.containsPredictedMPP)
            {
                decidingHomePoints = this.game.homeOdds_lu_mpp;
                decidingDrawPoints = this.game.drawOdds_lu_mpp;
                decidingAwayPoints = this.game.awayOdds_lu_mpp;
            }

            if(option == 'HOME')
            {
                if(decidingHomePoints >= decidingDrawPoints && decidingHomePoints >= decidingAwayPoints)
                {
                    return true;
                }
                else
                {
                    return false;
                }
            }
            else if(option == 'DRAW')
            {
                if(decidingDrawPoints > decidingHomePoints && decidingDrawPoints > decidingAwayPoints)
                {
                    return true;
                }
                else
                {
                    return false;
                }
            }
            else
            {
                if(decidingAwayPoints >= decidingHomePoints && decidingAwayPoints >= decidingDrawPoints)
                {
                    return true;
                }
                else
                {
                    return false;
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
